export enum InvoiceBuyerApprovalStatus {
    /** 0 */
    IN_REVIEW = 'IN_REVIEW',
    /** 1 */
    APPROVED = 'APPROVED',
    /** 2 */
    REJECTED = 'REJECTED'
}
